import {Trans} from '@lingui/macro';
import {Divider} from '@material-ui/core';
import React from 'react';
import ProfCourseGrid from '../component/ProfCourseGrid';

const profCoursePage = () => {
  return (
    <>
      <h2 className="TitleGrid">
        <Trans>Profile-Course</Trans>
      </h2>
      <Divider variant="middle" style={{marginBottom: 10}} />
      <ProfCourseGrid />
    </>
  );
};

export default profCoursePage;
